import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {PagedRequestDTO} from '../../common/models/PagedRequestDTO';
import {Observable} from 'rxjs';
import {PagedResponseDTO} from '../../common/models/PagedResponseDTO';
import {ProviderDTO} from '../models/ProviderDTO';
import {RefillDTO} from '../../pbm/models/RefillDTO';
import {ReturnMessageDTO} from '../../clm/models/ReturnMessageDTO';
import {ProviderGroupDTO} from '../models/ProviderGroupDTO';

@Injectable({
  providedIn: 'root'
})
export class ProviderGroupService {
  private url = environment.baseUrl + '/provider-group';

  constructor(private httpClient: HttpClient) {
  }

  getListOfProviderGroups(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<ProviderGroupDTO>> {
    return this.httpClient.post<PagedResponseDTO<ProviderGroupDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  getProviderGroup(providerId: number): Observable<ProviderGroupDTO> {
    return this.httpClient.get<ProviderGroupDTO>(this.url + '/' + providerId);
  }

  addProviderGroup(payload): Observable<any> {
    return this.httpClient.post<any>(this.url, payload);
  }

  deleteProviderGroup(id: number) {
    return this.httpClient.delete<{}>(this.url + '/' + id);
  }

}
